export default {
    IsRightToLeftOriented: false,
    HeaderTime: "Time",
    HeaderImpact: "Impact",
    HeaderEvent: "Event",
    HeaderActual: "Actual",
    HeaderDeviation: "Dev",
    HeaderDeviationTooltip:
        "Deviation: it measures the surprise caused when the Actual data differs from the Consensus. It can oscillate in a open scale usually between -7 and +7.",
    HeaderConsensus: "Consensus",
    HeaderPrevious: "Previous",
    TitleMob: "Economic Calendar",
    HeaderActualMob: "ACT:",
    HeaderDeviationMob: "DEV:",
    HeaderPreviousMob: "PREV:",
    HeaderConsensusMob: "CONS:",
    RowPreliminaryAbbreviation: "Prel",
    RowActual: "Actual",
    RowDeviation: "Dev",
    RowConsensus: "Consensus",
    RowPrevious: "Previous",
    RowSpeech: "Speech",
    RowReport: "Report",
    RowAllDay: "All Day",
    RowNotAvailable: "N/A",
    Dashboard: "Dashboard",
    DetailLink: "Official Source",
    DetailAddEvent: "Add Event",
    DetailEventDescription: "Description",
    DetailEventDateDescription: "Editor's notes",
    PreviousTooltip: "Revised from {0}",
    LongDateFormat: "", // LLLL_noTimeYear
    Period_DateFormat_Day: "mmm d", // copiar de historical widget
    Period_DateFormat_Month: "mmm",
    Period_QuarterFormat: "Q{0}",
    MinuteAbbreviation: "'",
    ErrorConnectMessage: "An connection error has occurred, refresh the browser please.",
    NoDataWidgetErrorMessageLine1: "Sorry, no results were found.",
    NoDataWidgetErrorMessageLine2: "Please try again shortly.",
    WidgetErrorMessageLine1: "Sorry, this tool is unavailable at this moment.",
    WidgetErrorMessageLine2: "Please try again shortly.",
    Potency: {
        ZERO: "",
        K: "K",
        M: "M",
        B: "B",
        T: "T",
    },
    TimeFilter_RecentNext: "Recent & Next",
    TimeFilter_Today: "Today",
    TimeFilter_Tomorrow: "Tomorrow",
    TimeFilter_ThisWeek: "This week",
    TimeFilter_ThisMonth: "This month",
    TimeFilter_NextWeek: "Next week",
    TimeFilter_NextMonth: "Next month",
    TimeFilter_Yesterday: "Yesterday",
    TimeFilter_PreviousWeek: "Previous week",
    TimeFilter_PreviousMonth: "Previous month",
    VolatilityFilterTitle: "Impact",
    VolatilityFilterTitleFormat: "{0}",
    Volatility_All: "All",
    Volatility_None: "None",
    Volatility_Low: "Low",
    Volatility_Medium: "Medium",
    Volatility_High: "High",
    CountryFilterTitle: "Country",
    Country_All: "All",
    Country_Belgium: "Belgium",
    Country_India: "India",
    Country_Greece: "Greece",
    Country_Switzerland: "Switzerland",
    Country_SouthAfrica: "South Africa",
    Country_Hungary: "Hungary",
    Country_Russia: "Russia",
    Country_Chile: "Chile",
    Country_Brazil: "Brazil",
    Country_Indonesia: "Indonesia",
    Country_France: "France",
    Country_Spain: "Spain",
    Country_Italy: "Italy",
    Country_Ireland: "Ireland",
    Country_Romania: "Romania",
    Country_Japan: "Japan",
    Country_EuropeanMonetaryUnion: "Eurozone",
    Country_NewZealand: "New Zealand",
    Country_Canada: "Canada",
    Country_Poland: "Poland",
    Country_Turkey: "Türkiye",
    Country_China: "China",
    Country_HongKong: "Hong Kong SAR",
    Country_CzechRepublic: "Czech Republic",
    Country_SouthKorea: "South Korea",
    Country_Denmark: "Denmark",
    Country_Iceland: "Iceland",
    Country_Colombia: "Colombia",
    Country_Finland: "Finland",
    Country_Australia: "Australia",
    Country_Portugal: "Portugal",
    Country_Norway: "Norway",
    Country_Germany: "Germany",
    Country_Argentina: "Argentina",
    Country_Mexico: "Mexico",
    Country_UnitedStates: "United States",
    Country_UnitedKingdom: "United Kingdom",
    Country_Sweden: "Sweden",
    Country_Slovakia: "Slovakia",
    Country_Austria: "Austria",
    Country_Singapore: "Singapore",
    Country_Netherlands: "Netherlands, The",
    Country_Israel: "Israel",
    Country_Ukraine: "Ukraine",
    Country_SaudiArabia: "Saudi Arabia",
    Country_Vietnam: "Vietnam",
    Country_Kuwait: "Kuwait",
    Country_Egypt: "Egypt",
    Country_UnitedArabEmirates: "United Arab Emirates",
    Country_Qatar: "Qatar",
    Country_Thailand: "Thailand",
    CategoryFilterTitle: "Category",
    Category_All: "All",
    Category_CentralBanks: "Central Banks",
    Category_LiquidityBalance: "Liquidity & Balance",
    Category_IndustrialNonIndustrialActivity: "Industrial & Non-Industrial Activity",
    Category_Holidays: "Holidays",
    Category_ConsumptionInflation: "Consumption & Inflation",
    Category_ConfidenceIndices: "Confidence Indices",
    Category_Employment: "Employment",
    Category_InterestRates: "Interest Rates",
    Category_Government: "Government",
    TimezoneFilterSetAutomatically: "Set automatically",
    MyFilterLabel: "My Filter",
    DefaultsFilterLabel: "Default",
    AdvancedFilterLabel: "Filter",
    NotificationsLabel: "Notifications",
    DateSelectorApply: "Apply",
    FilterApplyLabel: "Apply filter",
    FilterCancelLabel: "Cancel",
    FilterDoneLabel: "Done",
    FilterSaveLabel: "Save settings in My filter",
    FilterSaveMobileLabel: "Save settings",
    AdvancedFilterEventNameLabel: "Search event",
    AdvancedFilterCountriesLabel: "Countries",
    AdvancedFilterCategoriesLabel: "Categories",
    AdvancedFilterImpactLabel: "Impact",
    AdvancedFilterNoneLabel: "Clear",
    AdvancedFilterAllLabel: "Select All",
    MobileFilterFilters: "Filters",
    LegendDeviation: "Deviation",
    LegendDeviationDescription:
        "It measures the surprise caused when the Actual data differs from the Consensus. It can oscillate in an open scale usually between -7 and +7.",
    LegendColorCode: "Color Code",
    LegendAbbreviations: "Abbreviations",
    LegendColorCodeGreen: (w) => (
        <span>
            {w[0]("Green")}: {w[0]("better than expected")}{" "}
        </span>
    ),
    LegendColorCodeRed: (w) => (
        <span>
            {w[0]("Red")}: {w[0]("worse than expected")}
        </span>
    ),
    LegendAbbreviationsMoM: (w) => <span>{w[0]("MoM:")} Month-over-month</span>,
    LegendAbbreviationsYoY: (w) => <span>{w[0]("YoY:")} Year-over-year</span>,
    LegendAbbreviationsQoQ: (w) => <span>{w[0]("QoQ:")} Quarter-over-quarter</span>,
    Category_Consumption: "Consumption",
    Category_LaborMarket: "Labor Market",
    Category_Inflation: "Inflation",
    Category_HousingMarket: "Housing Market",
    Category_EconomicActivity: "Economic Activity",
    Category_CapitalFlows: "Capital Flows",
    Category_BondAuctions: "Bond Auctions",
    Category_Energy: "Energy",
    Category_Politics: "Politics",
    ShowPeriodLegend: true,
    TradeNow: "Trade Now",
    Download: "Download",
    ICS: "ICS",
    CSV: "CSV",
    ShowMore: "Show More",
    ShowLess: "Show Less",
    Menu_Overview: "Overview",
    NotifyMe: "Notify me",
    TimeFilter_Custom: "Custom",
    InvalidDateRange: "Start date must not be later than end date",
    DatePicker_None: "none",
    DatePicker_BeginDate: "Begin date",
    DatePicker_EndDate: "End date",
    DatePicker_Apply: "Apply",
    DatePickerMobile_ChooseDate: "Choose date",
    AdvancedTimeFilter_Description: "By default events are displayed by Recent and next",
    AdvancedTimeFilter_Selector: "Select other preferred time range:",
    AdvancedFilter_Search_Country: "Search country",
    TimeZone_TimeFormat: "Time format:",
    ResultsFor: "Results for:",
    SoundAlert: "Sound Alert",
    SoundAlertDescription:
        "The sound alert for new event releases is disabled by default. You can change it inside Calendar settings",
    Loading: "Loading...",
    ManageEventList: "Manage event list",
    ViewMore: "View more",
    Success_Message: "Your calendar visualization has changed succesfully",
    DetailEventDateSourceLabel: "Source:",
    DetailEventDateMattersTradersTitle: "Why it matters to traders?",
    DetailEventFetchError: "Error fetching event detail",
    DetailEventReadFullReport: "Read full report",
    DetailEventFrequency: "Frequency:",
    DetailEventNextRelease: "Next release:",
    DetailEventReleaseIrregular: "Irregular",
    DetailEventReleaseWeekly: "Weekly",
    DetailEventReleaseMonthly: "Monthly",
    DetailEventReleaseQuarterly: "Quarterly",
    Pop_Up_Title: "Your filters will be reset. Do you want to change view?",
    Pop_Up_Summary:
        "If you change view, your previously saved filters will reset to default. Confirm you want to continue.",
    Pop_Up_Cancel_Button: "Cancel",
    Pop_Up_Confirm_Button: "Change view",
    RelatedNewsTitle: "Related news",
    ByAuthor: "By",
    ErrorFetchingNews: "No news related to this event found.",
    GMT: "GMT",
    Close: "Close",
    BlockedPopup_MoreInfo: "How to enable push notifications",
    BlockedPopup_Summary:
        "Please allow permission to FXStreet to show push notifications when browsing our site to receive updates.",
    AddEvent: "Add event",
    Accept: "Accept",
    Notify_You_Top: "We are going to notify you!",
    Notify_You_Info:
        "You will receive a browser notification <strong>30 minutes before</strong> the event starts and another one just after the event is released.",
    Dont_Show_Again: "Don't show me this message again",

    TrackerLocked: "locked",
    Dovish: "Dovish",
    Neutral: "Neutral",
    Hawkish: "Hawkish",
    NA: "N/A",
    DetailEventDateUnlock: "Unlock the Speech Tracker",
    LogIn: "Log in",
    SpeechTrackerMean: "What does the Speech Tracker mean?",
    SpeechTrackerScoreLabel: "Sentiment/score",
    SpeechTrackerModalTitle: "New Speech Tracker",
    SpeechTrackerModalDescription:
        "The speech tracker gives you instant verdicts about central banker speeches directly in the FXStreet Economic Calendar. Log in now and get access to:",
    SpeechTrackerModalDisclaimer:
        "The result of the speech will be represented by its sentiment and a score in the 0-10 scale.",
    ReadMore: "Read more",
    VotingMember: "Voting member",
    Voting: "Voting",
    Average: "Average",
    Yes: "Yes",
    No: "No",
    InProgress: "In progress",
};
